// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-switch.is-disabled[data-v-7d93393a] {\n  opacity: 1;\n}\n[data-v-7d93393a] .el-switch__label {\n  cursor: pointer !important;\n}", ""]);
// Exports
module.exports = exports;
